import { MainRepositoryInterface } from '@/data/persistences/repositories/contracts/MainRepositoryInterface'
import { Pagination, ReportData } from '@/domain/entities/Main'
import { injectable } from 'tsyringe'

@injectable()
export class MainPresenter {
  private repository: MainRepositoryInterface

  constructor(repository: MainRepositoryInterface) {
    this.repository = repository
  }

  public getReportList(params: Pagination): Promise<ReportData> {
    return this.repository.getReportList(params)
  }
}
